// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Grid,
//   Paper,
//   Typography,
//   Button,
//   CircularProgress
// } from "@mui/material";

// const API_URL = process.env.REACT_APP_API_URL;

// export default function AdminAppointments() {
//   const [appointments, setAppointments] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // useEffect(() => {
//   //   const fetchAppointments = async () => {
//   //     try {
//   //       const res = await fetch(`${API_URL}/list_all_appointments/`);
//   //       const data = await res.json();
//   //       setAppointments(data.results || []);
//   //     } catch (err) {
//   //       console.error("Error:", err);
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   };

//   //   fetchAppointments();
//   // }, []);
//  useEffect(() => {
//   const fetchAppointments = async () => {
//     try {
//       const token = localStorage.getItem("token");

//       const res = await fetch(`${API_URL}/list-all-appointments/`, {
//         headers: {
//           Authorization: `Token ${token}`, // or Bearer
//           "Content-Type": "application/json",
//         },
//       });

//       // ✅ Debug status first
//       console.log("Status:", res.status);

//       if (!res.ok) {
//         const text = await res.text();
//         console.error("HTTP error:", res.status, text);
//         return;
//       }

//       const data = await res.json();

//       // ✅ DEBUG EVERYTHING
//       console.log("FULL RESPONSE:", data);
//       console.log("RESULTS ARRAY:", data.results);

//       setAppointments(data.results || []);

//     } catch (err) {
//       console.error("Fetch error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchAppointments();
// }, []);


//   if (loading) {
//     return (
//       <Box sx={{ textAlign: "center", mt: 10 }}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ p: 4, background: "#000", minHeight: "100vh" }}>
//       <Typography variant="h4" sx={{ color: "#fff", mb: 3 }}>
//         All Appointments
//       </Typography>

//       <Grid container spacing={3}>
//         {appointments.map((a) => (
//           <Grid item xs={12} md={6} key={a.id}>
//             <Paper
//               sx={{
//                 p: 3,
//                 borderRadius: 3,
//                 background: "#111",
//                 color: "#fff"
//               }}
//             >
//               {/* Topic */}
//               <Typography variant="h6">{a.topic_name}</Typography>

//               {/* User + Expert */}
//               <Typography sx={{ mt: 1 }}>
//                 👤 User: {a.user_name}
//               </Typography>

//               <Typography>
//                 🎓 Expert: {a.expert_name}
//               </Typography>

//               {/* Date */}
//               <Typography sx={{ mt: 1 }}>
//                 🗓 {a.date} • {a.time}
//               </Typography>

//               {/* Status */}
//               <Typography sx={{ mt: 1 }}>
//                 Status:{" "}
//                 <span style={{
//                   color: a.status === "completed" ? "#4caf50" : "#ff9800"
//                 }}>
//                   {a.status}
//                 </span>
//               </Typography>

//               {/* Actions */}
//               <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
                
//                 {/* ✅ Join */}
//                 {a.status !== "completed" && (
//                   <Button variant="contained" color="success">
//                     Join
//                   </Button>
//                 )}

//                 {/* 🎥 Recording */}
//                 {a.status === "completed" && a.recording_url && (
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     onClick={() => window.open(a.recording_url, "_blank")}
//                   >
//                     View Recording
//                   </Button>
//                 )}

//               </Box>
//             </Paper>
//           </Grid>
//         ))}
//       </Grid>
//     </Box>
//   );
// }

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Box, CircularProgress, Typography } from "@mui/material";

const API_URL = process.env.REACT_APP_API_URL;

const STATUS_STYLES = {
  completed: {
    label: "Completed",
    color: "#4caf50",
    bg: "#0d2e1a",
    border: "#1a5c2e",
  },
  pending: {
    label: "Pending",
    color: "#f59e0b",
    bg: "#2e1f05",
    border: "#5c3d0a",
  },
  upcoming: {
    label: "Upcoming",
    color: "#60a5fa",
    bg: "#0d1a2e",
    border: "#1a3d5c",
  },
};

function StatusBadge({ status }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.pending;
  return (
    <span
      style={{
        fontSize: 11,
        fontWeight: 500,
        padding: "3px 9px",
        borderRadius: 20,
        whiteSpace: "nowrap",
        flexShrink: 0,
        color: s.color,
        background: s.bg,
        border: `0.5px solid ${s.border}`,
      }}
    >
      {s.label}
    </span>
  );
}

function AppointmentCard({ a }) {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        background: "#111",
        border: "0.5px solid #222",
        borderRadius: "14px",
        p: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "14px",
        transition: "border-color 0.2s",
        "&:hover": { borderColor: "#333" },
      }}
    >
      {/* Top row: topic + status */}
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1 }}>
        <Typography sx={{ fontSize: 15, fontWeight: 600, color: "#f0f0f0", lineHeight: 1.3 }}>
          {a.topic_name}
        </Typography>
        <StatusBadge status={a.status} />
      </Box>

      {/* Divider */}
      <Box sx={{ height: "0.5px", background: "#1e1e1e" }} />

      {/* User + Expert */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "7px" }}>
        <MetaRow icon="user" value={a.user_name} />
        <MetaRow icon="expert" value={a.expert_name} />
      </Box>

      {/* Date + Time pill */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          background: "#161616",
          border: "0.5px solid #1e1e1e",
          borderRadius: "8px",
          px: "12px",
          py: "8px",
          fontSize: 13,
        }}
      >
        <CalendarIcon />
        <span style={{ color: "#e0e0e0", fontWeight: 500 }}>{a.date}</span>
        <span style={{ color: "#444" }}>·</span>
        <span style={{ color: "#888" }}>{a.time}</span>
      </Box>

      {/* Actions */}
      <Box sx={{ display: "flex", gap: "8px" }}>
        {a.status !== "completed" && (
         <ActionButton
  variant="join"
  onClick={() => navigate(`/meeting/${a.booking_id}?role=admin`)}
>
  Join Session
</ActionButton>
        )}
        {a.status === "completed" && a.recording_url && (
          <ActionButton variant="recording" onClick={() => window.open(a.recording_url, "_blank")}>
            View Recording
          </ActionButton>
        )}
        {a.status === "completed" && !a.recording_url && (
          <ActionButton variant="disabled">No Recording</ActionButton>
        )}
      </Box>
    </Box>
  );
}

function MetaRow({ icon, value }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "8px", fontSize: 13, color: "#888" }}>
      {icon === "user" ? <UserIcon /> : <ExpertIcon />}
      <span style={{ color: "#c8c8c8" }}>{value}</span>
    </Box>
  );
}

const BTN_VARIANTS = {
  join:      { bg: "#1a3d1a", color: "#4caf50", border: "#2a5c2a" },
  recording: { bg: "#1a2a3d", color: "#60a5fa", border: "#1a3d5c" },
  disabled:  { bg: "#1a1a1a", color: "#555",    border: "#2a2a2a" },
};

function ActionButton({ variant, onClick, children }) {
  const s = BTN_VARIANTS[variant];
  return (
    <button
      onClick={onClick}
      style={{
        padding: "7px 14px",
        borderRadius: 8,
        fontSize: 12,
        fontWeight: 500,
        cursor: onClick ? "pointer" : "default",
        background: s.bg,
        color: s.color,
        border: `0.5px solid ${s.border}`,
        fontFamily: "inherit",
      }}
    >
      {children}
    </button>
  );
}

// Minimal inline SVG icons
const CalendarIcon = () => (
  <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
    <rect x="2" y="3" width="12" height="11" rx="2" stroke="#555" strokeWidth="1.2" />
    <path d="M5 1v3M11 1v3M2 7h12" stroke="#555" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

const UserIcon = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ opacity: 0.6, flexShrink: 0 }}>
    <circle cx="8" cy="5" r="3" stroke="#888" strokeWidth="1.2" />
    <path d="M2 13c0-3.3 2.7-5 6-5s6 1.7 6 5" stroke="#888" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

const ExpertIcon = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ opacity: 0.6, flexShrink: 0 }}>
    <rect x="2" y="2" width="12" height="12" rx="3" stroke="#888" strokeWidth="1.2" />
    <path d="M5 8h6M5 11h3" stroke="#888" strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);

export default function AdminAppointments() {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();


  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(`${API_URL}/list-all-appointments/`, {
          headers: {
            Authorization: `Token ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (!res.ok) {
          console.error("HTTP error:", res.status, await res.text());
          return;
        }

        const data = await res.json();
        setAppointments(data.results || []);
      } catch (err) {
        console.error("Fetch error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchAppointments();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
        <CircularProgress sx={{ color: "#444" }} />
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: "24px 16px", sm: "32px 28px" }, background: "#0a0a0a", minHeight: "100vh" }}>
      {/* Header */}
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: "32px", flexWrap: "wrap", gap: "12px" }}>
        <Typography sx={{ fontSize: 22, fontWeight: 600, color: "#f5f5f5", letterSpacing: "-0.3px" }}>
          All Appointments
        </Typography>
        <Box
          sx={{
            background: "#1a1a1a",
            border: "0.5px solid #2a2a2a",
            color: "#888",
            fontSize: 12,
            px: "10px",
            py: "4px",
            borderRadius: "20px",
          }}
        >
          {appointments.length} appointment{appointments.length !== 1 ? "s" : ""}
        </Box>
      </Box>

      {/* Empty state */}
      {appointments.length === 0 ? (
        <Box sx={{ textAlign: "center", mt: 10, color: "#444" }}>
          <Typography sx={{ fontSize: 15 }}>No appointments found</Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              lg: "repeat(3, 1fr)",
            },
            gap: "16px",
          }}
        >
          {appointments.map((a) => (
            <AppointmentCard key={a.id} a={a} />
          ))}


        </Box>
      )}
    </Box>

  );
}